"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "form-page" };
const _hoisted_2 = { class: "card-container" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "card-rows" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "card-row" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "left" }, "Típusa"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "right" }, "személygépkocsi")
    ]),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "card-row" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "left" }, "Foglalható"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "right" }, "Igen")
    ])
], -1);
const Card_vue_1 = __importDefault(require("../../../../components/backend/Card/Card.vue"));
const CustomButton_vue_1 = __importDefault(require("../../../../components/backend/CustomButton.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'LocationFormServiceStations',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                    "btn-type": "primary",
                    class: "w-98"
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)("ÚJ ÁLLÁS HOZZÁADÁSA ")
                    ]),
                    _: 1
                }),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(5, (n, index) => {
                        return (0, vue_2.createVNode)(Card_vue_1.default, {
                            key: index,
                            title: `SZGK 0${index + 1}`
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                _hoisted_3,
                                (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                                    "default-icon": false,
                                    "btn-type": "transparent"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                            class: "icon",
                                            icon: ['far', 'pen-to-square']
                                        }),
                                        (0, vue_2.createTextVNode)(" Állás szerkesztése")
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 2
                        }, 1032, ["title"]);
                    }), 64))
                ])
            ]));
        };
    }
});
